var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-text-field',{attrs:{"value":_vm.display,"prefix":"$","readonly":"","height":"24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }